export class DriverLicenceModel {
  public dateOfBirth: string;
  public DriverLicenceNumber: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/validatedriverlicence/models/driverlicencedetail.model.ts